// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_fo-0";
export var actionModalContentContainer = "_fo-1";